<template>
  <div class="dashboard-container">
    <!-- 任务状态筛选 -->
    <div class="state_style">
      <div>
        <span
          class="state_btn"
          :class="{ selected: formInline.synergeticState === 'DWC' }"
          @click="switchCompletionStatus('DWC')"
          >待执行 ( <span style="color: red">{{ remindNum }}</span> )</span
        >

        <span> 丨 </span>
        <span
          class="state_btn"
          :class="{ selected: formInline.synergeticState === 'All' }"
          @click="switchCompletionStatus('All')"
          >全部</span
        >
      </div>
      <div style="margin-top: 3px">
        <el-button
          type="warning"
          plain
          icon="el-icon-back"
          @click="goBack"
          size="small"
          >返回</el-button
        >
      </div>
    </div>
    <!-- 任务列表 -->
    <div
      v-if="total !== 0"
      v-infinite-scroll="load"
      class="data_container"
      :infinite-scroll-delay="200"
      :infinite-scroll-distance="50"
      :infinite-scroll-immediate="disabled"
    >
      <waterfall
        :col="col"
        :width="itemWidth"
        :gutter-width="gutterWidth"
        :data="tableData"
      >
        <template>
          <div v-for="(item, index) in tableData" :key="index">
            <!-- 技术方案 -->
            <technicalProposal
              v-if="item.modleType === 'JSFA' || item.modleType === 'JSFAXG'"
              :key="item.boxId + new Date() + item.modleType"
              :data-object="item"
              :personnel-list="personnelList"
              :btnauth="btnauth"
              @renewList="renewList"
            />
            <!-- 补充合同盖章 -->
            <supplementaryContractSeal
              v-if="item.modleType === 'HT'"
              :key="item.boxId"
              :personnel-list="personnelList"
              :data-object="item"
              :btnauth="btnauth"
              @renewList="renewList"
            />
            <!-- 补充个人资料 -->
            <personalData
              v-if="item.modleType === 'GRZL'"
              :key="item.boxId"
              :data-object="item"
              :personnel-list="personnelList"
              :btnauth="btnauth"
              @renewList="renewList"
            />
            <!-- 补充项目报告 -->
            <projectReports
              v-if="item.modleType === 'BG'"
              :key="item.boxId"
              :data-object="item"
              :personnel-list="personnelList"
              :btnauth="btnauth"
              @renewList="renewList"
            />
            <!-- 投标保证金 -->
            <depositPayment
              v-if="item.modleType === 'BZJ'"
              :key="item.boxId"
              :data-object="item"
              :personnel-list="personnelList"
              :btnauth="btnauth"
              @renewList="renewList"
            />
          </div>
        </template>
      </waterfall>
    </div>
    <!-- 暂无数据 -->
    <el-empty v-if="total === 0" description="暂无数据"></el-empty>
  </div>
</template>

<script>
import { boxList, boxCount } from '@/api/bidBox'
import { getEmplList } from '@/api/publiccommon'
import technicalProposal from '@/components/bidTaskBoxCollection/technicalProposal'// 技术方案
import supplementaryContractSeal from '@/components/bidTaskBoxCollection/supplementaryContractSeal'// 补充合同盖章扫描件
import personalData from '@/components/bidTaskBoxCollection/personalData'// 补充个人资料扫描件
import projectReports from '@/components/bidTaskBoxCollection/projectReports'// 补充项目报告扫描件
import depositPayment from '@/components/bidTaskBoxCollection/depositPayment'// 补充项目报告扫描件
export default {
  name: '',
  components: {
    technicalProposal,
    supplementaryContractSeal,
    personalData,
    projectReports,
    depositPayment
  },
  props: {

  },
  data () {
    return {
      btnauth: [], // 权限
      formInline: {
        synergeticState: 'DWC',
        queryType: 'HZ',
        pageNum: 1,
        pageSize: 6
      },
      total: 0,
      remindNum: 0, // 提醒数量
      col: 3, // 每列多少条 数据
      tableData: [], // 数据
      personnelList: [], // 人员列表
      disabled: false
    }
  },
  computed: {
    itemWidth () {
      return (243 * 0.5 * (document.documentElement.clientWidth / 390))
    },
    gutterWidth () {
      return (9 * 0.5 * (document.documentElement.clientWidth / 390))
    }
  },
  watch: {

  },
  created () {
    this.getBoxList()
    this.getEmplList()
    this.getBoxCount()
  },
  mounted () {

  },
  methods: {
    // getauth () {
    //   getLimits(this.$route.meta.mId).then(res => {
    //     if (res.status === 200) {
    //       this.btnauth = res.data
    //     }
    //   })
    // },
    // 获取盒子列表
    getBoxList () {
      boxList(this.formInline).then(res => {
        this.tableData = res.data.list || []
        this.total = res.data.total || 0
      })
    },
    // 获取盒子消息提醒数量
    getBoxCount () {
      boxCount({}).then(res => {
        if (res.status === 200) {
          this.remindNum = res.data.msgCount || 0
        }
      })
    },
    // 切换类型下 项目状态
    switchCompletionStatus (type) {
      this.disabled = false
      this.formInline.synergeticState = type
      this.formInline.pageNum = 1
      this.getBoxList()
      this.getBoxCount()
    },
    // 下拉加载
    load () {
      if (this.disabled) {
        return
      }
      if (this.tableData.length <= this.total) {
        this.formInline.pageNum += 1
        boxList(this.formInline).then(res => {
          this.tableData = this.tableData.concat(res.data.list || [])
        })
      }
      if (this.tableData.length >= this.total) {
        this.disabled = true
      }
    },
    // 获取人员列表
    getEmplList () {
      getEmplList({}).then(res => {
        if (res.status === 200) {
          this.personnelList = res.data.list || []
        }
      })
    },
    // 组件触发事件
    renewList () {
      this.formInline.pageNum = 1
      this.getBoxList()
      this.getBoxCount()
    },
    // 返回上一页
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 20px;
  box-sizing: border-box;
  margin-left: 10px;
  overflow-y: auto;
  background-color: #ffffff;
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.state_style {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  font-size: 24px;
  .state_btn {
    font-weight: 600;
    cursor: pointer;
  }
}
.selected {
  color: rgb(3, 81, 251) !important;
}
.data_container {
  height: 80vh;
  overflow: auto;
}
</style>
